import { faker } from '@faker-js/faker'

import { getMedicalCase } from './MedicalCase'

import { ServiceOfferDetailsView, TimeUnit } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getDescriptionTemplate = asBuilder((): ServiceOfferDetailsView['descriptionTemplate'] => ({
  procedureRecommended: {
    items: faker.helpers.multiple(() => ({ description: faker.lorem.sentence() })),
  },
  procedureProcess: {
    totalProcedureMinutes: faker.number.int(),
    items: faker.helpers.multiple(() => ({ description: faker.lorem.sentence() })),
  },
  medicalCases: { items: [getMedicalCase(), getMedicalCase()] },
  sideEffects: { description: faker.lorem.sentence() },
  downtime: {
    value: faker.number.int(),
    type: faker.helpers.enumValue(TimeUnit),
  },
}))
